export default function HomePage() {
  return (
    <>
      <h2 className="text-xl font-bold">Welcome to the homepage!</h2>
      <p>This is your new layout using JSX in Next.js 16.</p>
      </>
  
  );
}